import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
//Openlayer
import { Map, View } from 'ol';
import { OSM, XYZ } from 'ol/source';
import TileWMS from 'ol/source/TileWMS';
import LayerGroup from 'ol/layer/Group';
import { fromLonLat } from 'ol/proj';
import Control from 'ol/control/Control';
import LayerSwitcher from 'ol-layerswitcher';
import Overlay from 'ol/Overlay';
import OlStyle from 'ol/style/Style';
import VectorImageLayer from 'ol/layer/VectorImage';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { Circle, Fill, Stroke, Style, Icon, Text } from 'ol/style.js';
import RegularShape from 'ol/style/RegularShape'; // 💡 ใช้ RegularShape หรือ Circle ที่มี points
import Snap from 'ol/interaction/Snap';
import { LineString, Polygon } from 'ol/geom';
import { getArea, getLength } from 'ol/sphere.js';
import { unByKey } from 'ol/Observable.js';
import Draw from 'ol/interaction/Draw.js';
import * as olProj from 'ol/proj';
import ImageLayer from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';
import { bbox as bboxStrategy } from 'ol/loadingstrategy.js';
import VectorTileLayer from 'ol/layer/VectorTile.js';
import VectorTileSource from 'ol/source/VectorTile.js';
import MVT from 'ol/format/MVT.js';
import { getCenter } from 'ol/extent';
import { Point } from 'ol/geom';
import Cluster from 'ol/source/Cluster';
import Feature from 'ol/Feature.js';
import Geolocation from 'ol/Geolocation.js';
//MUI
import { Button, Box, Typography, TextField, MenuItem, Snackbar, Alert } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
//Component
import BackDropLoading from '../Layouts/BackDropLoading'
import ParceInfoAccordion from './ChildComponent/ParcelInfoAccordion'
//Hooks
import useVerifyToken from '../../hooks/useVerifyToken'
import useFetchLtaxData from './Hooks/useFetchLtaxData';
import useFetchSurveyData from './Hooks/useFetchSurveyData';
import axiosSmartSurvey from '../../api/axios';
import useAuth from '../../hooks/useAuth.jsx';
import useAuthentication from '../Authen/Hooks/useAuthentication.jsx'
import useFetchFileData from '../Taxmapfolder/hooks/useFetchFileData.jsx';
//Icon
import SearchIcon from '@mui/icons-material/Search';
import MapIcon from '@mui/icons-material/Map';
import CreateIcon from '@mui/icons-material/Create';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import StraightenIcon from '@mui/icons-material/Straighten';
import FolderIcon from '@mui/icons-material/Folder';

//Ant Design
import { Row, Col, Image, Modal, Divider } from "antd";

//Roles
import {
    ROLE_ADMIN,
    ROLE_TAXMAP,
    ROLE_PROPERTY_REGISTER,
    ROLE_WELFARE,
    ROLE_REVENUE,
    ROLE_ANY,
    ROLE_PUBLIC_WORKS,
    SURVEY_NAV_ROLES
} from '../../constants/roles.jsx';

//Database
var dataWMS = process.env.REACT_APP_MAP_WMS;
var dataWFS = process.env.REACT_APP_MAP_WFS;
var dataGWC = process.env.REACT_APP_MAP_GWC


//theme
const theme = createTheme({
    palette: {
        neutral: {
            main: 'white',
            contrastText: '#fff',
        },
    },
    typography: {
        fontFamily: [
            'IBM Plex Sans Thai',
            'sans-serif',
        ].join(','),
    },
});

function MAP() {
    const [map, setMap] = useState();
    const mapElement = useRef();
    const mapRef = useRef();
    mapRef.current = map;
    const searchSelectRef = useRef()
    const tumbolQueryRef = useRef()
    const [landInfo, setLandInfo] = useState([]);
    const navigate = useNavigate();
    const [alertDnTest, setAlertDnTest] = useState()
    const [wasteFeeAlertUrl, setWasteFeeAlertUrl] = useState()
    const [noPayWasteFeeAlertUrl, setNoPayWasteFeeAlertUrl] = useState()
    const [googleMapLink, setGoogleMapLink] = useState([])
    const [surveyBuildings, setSurveyBuildings] = useState([])
    const [landImagesUrl, setLandImagesUrl] = useState([])
    const [buildingImagesURL, setBuildingImagesURL] = useState([])
    const [allBuildingInfo, setAllBuildingInfo] = useState([])
    const [searchValue, setSearchValue] = useState({
        select: 'เลขที่โฉนด',
        houseNo: '',
        road: '',
        moo: ''
    })
    const [droneLayerVisible, setDroneLayerVisible] = useState(false);
    const [searchErrorOpen, setSearchErrorOpen] = useState(false)
    const [searchErrorText, setSearchErrorText] = useState('')
    // Print Barcode
    const [oldParcel, setOldParcel] = useState()

    //E-Folder state
    const [parcelCode, setParcelCode] = useState()
    const [folderData, setFolderData] = useState([])
    const [fileTypeData, setFileTypeData] = useState([])
    const { fetchFileTypeData, fetchViewData } = useFetchFileData()
    const [isOpenFolderModal, setIsOpenFolderModal] = useState(false)
    const alertNoFolder = async (parcelCode) => {
        setSearchErrorOpen(true)
    }
    function handleFolderClose() {
        setIsOpenFolderModal(false)
        setFolderData([])
    }

    // Ltax Online Data
    const [ltaxOnlineData, setltaxOnlineData] = useState([])
    const [ltaxOnlineLands, setLtaxOnlineLands] = useState([])
    const [ltaxOnlineBuildings, setLtaxOnlineBuildings] = useState([])



    //Loading
    const [backDropLoading, setBackDropLoading] = useState(false)
    const [ltaxBuildingLoading, setLtaxBuildingLoading] = useState(false)
    const [ltaxOnlineBuildingLoading, setLtaxOnlineBuildingLoading] = useState(false)
    const [surveyBuildingLoading, setSurveyBuildingLoading] = useState(false)
    const [surveyImagesLoading, setSurveyImagesLoading] = useState(false)

    //Hooks Declare
    const { verifyToken } = useVerifyToken()
    const { fetchLtaxData, fetchParcelCode, fetchLtaxOnlineData, fecthLtaxOnlineAddress } = useFetchLtaxData()
    const { fetchSurveyImages, fetchSurveyBuilding } = useFetchSurveyData()
    const { user } = useAuth()

    // สกัด Roles ของ User ออกมาเช็คสิทธิ์
    const userRoles = Array.isArray(user?.roles)
        ? user.roles.map(String)
        : [String(user?.roles || '')];

    // เช็คว่าเป็นกลุ่ม Admin / แผนที่ภาษี / จัดเก็บทรัพย์สิน (100, 101, 102, 103, 104) หรือไม่
    const hasSurveyAccess = userRoles.some(role => SURVEY_NAV_ROLES.includes(role));

    var wasteFeeAlertStyle = new OlStyle({
        fill: new Fill({
            color: 'rgba(42, 224, 63, 0.8)'
        }),
        stroke: new Stroke({
            color: 'rgba(32, 189, 50, 0.8)',
            width: 3
        }),
        image: new Circle({
            radius: 7,
            fill: new Fill({
                color: '#e31a1c'
            })
        })
    })
    //Axios Alert
    const axiosSurveyAlert = async () => {
        var alertDn = '('
        var response = await axiosSmartSurvey({
            method: 'post',
            url: '/api/surveyalert'
        })
        response = response.data
        if (response?.length > 0) {
            await response.forEach((data, index) => {
                if (index < response.length - 1) {
                    alertDn = alertDn + data + ','
                } else {
                    alertDn = alertDn + data
                }
            })
        }
        alertDn = alertDn + ')'
        setAlertDnTest(alertDn)
    }
    const axiosWasteFeeAlert = async () => {
        var alertParcelCode = `(`
        var noPayAlertParcelCode = `(`
        var response = await axiosSmartSurvey({
            method: 'post',
            url: '/map/wastefee',
            //ต้องเปลี่ยนปีงบ
            data: {
                budgetYear: 2568
            }
        })
        const payParcelcode = response.data.payParcelcode
        // console.log(response)
        const noPayParcelCode = response.data.noPayParcelCode
        if (payParcelcode?.length > 0) {
            await payParcelcode.forEach((data, index) => {
                if (index < payParcelcode.length - 1) {
                    alertParcelCode = alertParcelCode + `'` + data + `'` + ','
                } else {
                    alertParcelCode = alertParcelCode + `'` + data + `'`
                }
            })
        }
        alertParcelCode = alertParcelCode + ')'
        if (noPayParcelCode?.length > 0) {
            await noPayParcelCode.forEach((data, index) => {
                if (index < noPayParcelCode.length - 1) {
                    noPayAlertParcelCode = noPayAlertParcelCode + `'` + data + `'` + ','
                } else {
                    noPayAlertParcelCode = noPayAlertParcelCode + `'` + data + `'`
                }
            })
        }
        noPayAlertParcelCode = noPayAlertParcelCode + ')'
        setWasteFeeAlertUrl(`${dataWFS}&version=2.0.0&request=GetFeature&srsname=EPSG:3857&typeName=SuratCityMap:Parcel`
            + `&CQL_FILTER=parcel_cod+IN+${alertParcelCode}`
            + `&outputFormat=application/json`)
    }

    // 🟢 ฟังก์ชันส่ง Log ไปหลังบ้าน
    const logMapActivity = (actionType, details = {}) => {
        axiosSmartSurvey.post('/logs/map-activity', {
            action_type: actionType, // 'SEARCH' หรือ 'VIEW_INFO'
            search_keyword: details.keyword || null,
            parcel_cod: details.parcel_cod || null,
            old_parcel: details.old_parcel || null,
        }).catch(err => console.error('Log tracking error:', err));
        // catch ไว้เฉยๆ ไม่ต้องให้แสดง Error ขึ้นหน้าจอผู้ใช้
    };

    useEffect(() => {
        verifyToken()
        axiosSurveyAlert()
        axiosWasteFeeAlert()
        fetchFileTypeData(setFileTypeData)
    }, [])


    useEffect(() => {
        if (alertDnTest) {
            // =========================================================
            // 💾 1. ส่วนควบคุมการจำสถานะ Layer Visibility (localStorage)
            // =========================================================
            const LAYER_STORAGE_KEY = 'surat_map_layer_visible_state';

            // อ่านค่าที่เคยเซฟไว้
            const getSavedVisibility = () => {
                try {
                    const saved = localStorage.getItem(LAYER_STORAGE_KEY);
                    return saved ? JSON.parse(saved) : {};
                } catch (e) {
                    return {};
                }
            };

            const savedVisibility = getSavedVisibility();

            // ฟังก์ชันช่วยตั้งค่าการมองเห็น + บันทึกเมื่อมีการเปลี่ยนค่า
            const applyVisibilityTracker = (layer, layerId, defaultVisible = true) => {
                layer.set('id', layerId); // กำหนด ID ไว้ใช้อ้างอิง

                // ถ้าเคยเซฟไว้ให้ใช้ค่านั้น ถ้าไม่เคยให้ใช้ defaultVisible
                const isVisible = savedVisibility.hasOwnProperty(layerId)
                    ? savedVisibility[layerId]
                    : defaultVisible;

                layer.setVisible(isVisible);

                // 🔑 คอยฟัง event เมื่อผู้ใช้กด ติ๊กเปิด/ปิด ใน LayerSwitcher
                layer.on('change:visible', () => {
                    try {
                        const currentSaved = getSavedVisibility();
                        currentSaved[layerId] = layer.getVisible();
                        localStorage.setItem(LAYER_STORAGE_KEY, JSON.stringify(currentSaved));
                    } catch (e) {
                        console.error('Could not save layer visibility:', e);
                    }
                });

                return layer;
            };


            const token = localStorage.getItem('token');

            //---- Map View ----
            var mapView = new View({
                center: fromLonLat([99.3309036236749, 9.139712449633054]),
                zoom: 17
            })
            // -------------------------------------------------------------
            // 1. ตั้งค่า Geolocation ของ OpenLayers
            // -------------------------------------------------------------

            const geolocation = new Geolocation({
                trackingOptions: {
                    enableHighAccuracy: true,
                },
                projection: mapView.getProjection(),
            });

            geolocation.setTracking(true);

            // 2. สร้าง Feature สำหรับ "จุดตำแหน่งปัจจุบัน" ตัวเดียว
            const positionFeature = new Feature();
            positionFeature.setStyle(new Style({
                image: new Circle({
                    radius: 7,
                    fill: new Fill({ color: '#3388ff' }),
                    stroke: new Stroke({ color: '#ffffff', width: 2.5 }),
                }),
            }));

            // 3. ใส่ Source และสร้าง Layer
            const locationSource = new VectorSource({
                features: [positionFeature],
            });

            const locationLayer = applyVisibilityTracker(new VectorLayer({
                title: 'ตำแหน่งปัจจุบัน',
                source: locationSource,
                zIndex: 9999,
            }), 'user_location', true);

            // 4. ดักจับพิกัดเปลี่ยน
            geolocation.on('change:position', function () {
                const coordinates = geolocation.getPosition();
                if (coordinates) {
                    positionFeature.setGeometry(new Point(coordinates));
                }
            });

            geolocation.on('error', function (error) {
                console.error('🚨 Geolocation error:', error.message);
            });

            // 🔑 1. ฟังก์ชันดึงพิกัดสดจาก Browser Native โดยตรง (ไม่ผ่านคิว OpenLayers)
            const forceFetchLocation = () => {
                if ('geolocation' in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        (pos) => {
                            const coords = [pos.coords.longitude, pos.coords.latitude];
                            // แปลงพิกัดจาก EPSG:4326 เป็น EPSG:3857 (สเปค OpenLayers)
                            const transformedCoords = fromLonLat(coords, mapView.getProjection());

                            if (positionFeature) {
                                positionFeature.setGeometry(new Point(transformedCoords));
                            }
                        },
                        (err) => console.log('Native GPS retry warning:', err.message),
                        { enableHighAccuracy: true, maximumAge: 0, timeout: 5000 }
                    );
                }
            };

            // 🔑 3. เรียกยิงพิกัดสด Native ทันที 1 รอบจังหวะแรกที่เข้าหน้า
            forceFetchLocation();
            //------------------------------------------------------------
            // --- Basemaps ---
            //------------------------------------------------------------
            var satellite = applyVisibilityTracker(new TileLayer({
                source: new XYZ({ url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}' }),
                title: 'Google Satellite',
                type: 'base'
            }), 'base_satellite', false);

            var osm = applyVisibilityTracker(new TileLayer({
                source: new OSM(),
                title: 'OpenStreetMap',
                type: 'base'
            }), 'base_osm', true);
            var basemapLayersGroup = new LayerGroup({
                title: 'ชั้นข้อมูลพื้นหลัง',
                layers: [
                    osm, satellite
                ]
            })

            //------------------------------------------------------------
            //--- Welfare ---
            //------------------------------------------------------------
            const communityAreaSource = new VectorSource({
                format: new GeoJSON(),
                loader: function (extent, resolution, projection) {
                    fetch(`${dataWFS}&version=2.0.0&request=GetFeature&srsname=EPSG:3857&typeName=SuratCityMap:Community_Area&outputFormat=application/json`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(geojson => {
                            const features = new GeoJSON().readFeatures(geojson, {
                                featureProjection: projection
                            });
                            communityAreaSource.clear();
                            communityAreaSource.addFeatures(features);
                        })
                        .catch(err => console.error('Error loading community area:', err));
                }
            });
            var communityArea = applyVisibilityTracker(new VectorLayer({
                title: 'ชั้นข้อมูลเขตชุมชน',
                source: communityAreaSource,
                style: communityAreaStyleFunction,
            }), 'welfare_community_area', false);
            function communityAreaStyleFunction(feature) {
                return new Style({
                    stroke: new Stroke({
                        color: '#08f120',
                        width: 2
                    }),
                    text: new Text({
                        text: feature.get('name') || '', // หรือเปลี่ยนเป็น 'parcel_cod' หรือ field ที่ต้องการ
                        fill: new Fill({ color: '#000' }),
                        stroke: new Stroke({
                            color: '#fff',
                            width: 2,
                        }),
                        overflow: true,
                        font: '14px sans-serif'
                    }),
                });
            }
            const elderSource = new VectorSource({
                format: new GeoJSON(),
                loader: function (extent, resolution, projection) {
                    fetch(`${dataWFS}&version=2.0.0&request=GetFeature&srsname=EPSG:3857&typeName=SuratCityMap:Elder_People&outputFormat=application/json`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(geojson => {
                            const features = new GeoJSON().readFeatures(geojson, {
                                featureProjection: projection
                            });
                            elderSource.clear();
                            elderSource.addFeatures(features);
                        })
                        .catch(err => console.error('Error loading elder people:', err));
                }
            });
            var elderPeople = applyVisibilityTracker(new VectorLayer({
                title: 'ชั้นข้อมูลผู้สูงอายุ',
                source: elderSource,
                style: new Style({
                    image: new Icon({
                        src: 'https://openlayers.org/en/latest/examples/data/icon.png'
                    })
                }),
            }), 'welfare_elder_people', false);
            var welfareLayersGroup = new LayerGroup({
                title: 'ชั้นข้อมูลกองสวัสดิการฯ',
                layers: [communityArea, elderPeople]
            })
            var communityAreaLayersGroup = new LayerGroup({
                title: 'ชั้นข้อมูลกองสวัสดิการฯ',
                layers: [communityArea]
            })
            //------------------------------------------------------------
            // --- Measure Source ---
            //------------------------------------------------------------
            const source = new VectorSource()
            const measureVector = new VectorLayer({
                source: source,
                style: new Style({
                    fill: new Fill({
                        color: 'rgba(230, 230, 0, 1)'
                    }),
                    stroke: new Stroke({
                        color: 'rgba(255, 255, 0, 1)',
                        width: 3
                    }),
                })
            })
            //------------------------------------------------------------
            //--- Parcel ---
            //------------------------------------------------------------
            var parcel = applyVisibilityTracker(new TileLayer({
                title: 'ชั้นข้อมูลแปลงที่ดิน',
                source: new TileWMS({
                    url: dataWMS,
                    params: {
                        'LAYERS': 'SuratCityMap:Parcel'
                    },
                    ratio: 1,
                    serverType: 'geoserver',
                    tileLoadFunction: (imageTile, src) => {
                        fetch(src, {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        })
                            .then(res => res.blob())
                            .then(blob => {
                                const objectUrl = URL.createObjectURL(blob);
                                imageTile.getImage().src = objectUrl;
                            });
                    }
                }),
            }), 'tax_parcel', true);

            const parcelSource = new VectorSource({
                format: new GeoJSON(),
            });
            function parcelTextStyle(feature) {
                // ดึงค่าจาก attribute 'old_parcel'
                // console.log(feature)
                const labelText = feature.get('old_parcel');
                // console.log("Feature ID:", feature.getId(), "Label Value:", labelText); // <--- เพิ่มบรรทัดนี้เพื่อ debug
                return new Style({
                    // ทำให้ Polygon ตัวเอง 'โปร่งใส' เพื่อโชว์แต่ Text
                    fill: new Fill({ color: 'rgba(255, 255, 255, 0)' }),
                    stroke: new Stroke({ color: 'rgba(255, 255, 255, 0)' }),
                    text: new Text({
                        text: labelText,
                        font: 'bold 12px sans-serif',
                        fill: new Fill({ color: 'black' }),
                        stroke: new Stroke({ color: 'white', width: 3 }),
                        placement: 'point', // วาง Text ที่จุดศูนย์กลางของโพลีกอน
                    }),
                });
            }
            // Layer สำหรับแสดงรหัสแปลง (ใช้ Source ที่ถูกควบคุม)
            const parcelLabelLayer = applyVisibilityTracker(new VectorLayer({
                title: 'รหัสแปลงที่ดิน',
                source: parcelSource,
                style: parcelTextStyle,
                declutter: true,
                minZoom: 18
            }), 'tax_parcel_label', true);
            //------------------------------------------------------------
            //--- Building ---
            //------------------------------------------------------------
            var building = applyVisibilityTracker(new TileLayer({
                title: 'ชั้นข้อมูลสิ่งปลูกสร้าง',
                source: new TileWMS({
                    url: dataWMS,
                    params: {
                        'LAYERS': 'SuratCityMap:Building2569'
                    },
                    ratio: 1,
                    serverType: 'geoserver',
                    tileLoadFunction: (imageTile, src) => {
                        fetch(src, {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        })
                            .then(res => res.blob())
                            .then(blob => {
                                const objectUrl = URL.createObjectURL(blob);
                                imageTile.getImage().src = objectUrl;
                            });
                    }
                }),
            }), 'tax_building', true);
            const building2569Source = new VectorSource({
                format: new GeoJSON(),
            });
            function building2569TextStyle(feature, resolution) {
                const labelText = feature.get('address') || '';
                if (!labelText) return null;

                // 💡 คำนวณขนาดฟอนต์ตาม Resolution (ค่า resolution ยิ่งน้อย = ซูมเข้ายิ่งลึก)
                // Resolution: Zoom 18 ~ 0.6, Zoom 19 ~ 0.3, Zoom 20 ~ 0.15
                let fontSize = 10;
                if (resolution < 0.3) {
                    fontSize = 13; // ซูมใกล้มากๆ ขยายฟอนต์
                } else if (resolution < 0.6) {
                    fontSize = 11;
                }

                return new Style({
                    text: new Text({
                        text: String(labelText),
                        font: `bold ${fontSize}px sans-serif`,
                        fill: new Fill({ color: '#2b2b2b' }),
                        stroke: new Stroke({ color: '#ffea00', width: 3 }),
                        offsetY: -18,
                        overflow: false
                    })
                });
            }
            // Layer สำหรับแสดงรหัสแปลง (ใช้ Source ที่ถูกควบคุม)
            const building2569LabelLayer = applyVisibilityTracker(new VectorLayer({
                title: 'บ้านเลขที่',
                source: building2569Source,
                style: building2569TextStyle,
                declutter: true,
                minZoom: 18
            }), 'tax_building_label', true);
            //------------------------------------------------------------
            // --- Buildings LTAX ---
            //------------------------------------------------------------
            // 1. สร้าง Vector Source (ข้อมูลหมุด building_point)
            const buildingSource = new VectorSource({
                format: new GeoJSON(),
                // 🔑 ใช้ strategy: bbox เพื่อให้ OpenLayers เรียก loader เมื่อมีการซูม/เลื่อนแผนที่
                strategy: bboxStrategy, // ต้อง import 'ol/loadingstrategy.js' หรือใช้ ol.loadingstrategy
                loader: function (extent, resolution, projection) {

                    const crsCode = projection.getCode();
                    const bboxString = extent.join(',') + ',' + crsCode; // 👈 สร้าง BBOX String
                    const token = localStorage.getItem('token');

                    // 🔑 ปรับ URL ให้รวม BBOX Filter
                    const wfsUrl = `${dataWFS}` +
                        `&version=2.0.0&request=GetFeature&srsname=${crsCode}&typeName=SuratCityMap:BuildingPoint` +
                        `&outputFormat=application/json&CRS=${crsCode}` +
                        `&bbox=${bboxString}`; // 👈 ส่ง BBOX ไปใน URL

                    fetch(wfsUrl, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(geojson => {
                            const rawFeatures = new GeoJSON().readFeatures(geojson, {
                                featureProjection: projection
                            });

                            const featuresWithGeometry = rawFeatures.filter(f => f.getGeometry() !== null);

                            // 🛑 ไม่ต้อง clear() แล้วใช้ addFeatures() 
                            // แต่ให้ใช้ clear() แล้วเรียก source.addFeatures(features)
                            // OpenLayers จะจัดการการโหลดใหม่ใน BBOX ให้อัตโนมัติ
                            buildingSource.addFeatures(featuresWithGeometry);
                            ltaxBuildingLayer.changed();
                        })
                        .catch(err => console.error('Error loading buildingSource:', err));
                }
            });
            // **[ส่วนที่ 3: สร้าง Vector Layer ใหม่]**
            const ltaxBuildingLayer = applyVisibilityTracker(new VectorLayer({
                title: 'สิ่งปลูกสร้างจากLTAX',
                minZoom: 20,
                source: buildingSource,
                style: gridDisplacementStyle,
                zIndex: 999,
            }), 'tax_ltax_building', false);

            function gridDisplacementStyle(feature, resolution) {
                // ... โค้ดตรวจสอบ Geometry
                const geometry = feature.getGeometry();
                if (!geometry || geometry.getType() !== 'Point') {
                    return null;
                }

                const index = parseInt(feature.get('index_in_parcel'), 10) || 0;

                // 1. กำหนดความกว้างของตาราง (คอลัมน์/แถว)
                const gridWidth = 3; // 🚨 กำหนดให้มี 3 คอลัมน์ (0, 1, 2)
                const pixelSpacing = 50; // 🚨 ระยะห่างระหว่างหมุด (เป็น pixels)

                // 2. คำนวณตำแหน่งแถวและคอลัมน์
                const col = index % gridWidth; // ตำแหน่งคอลัมน์ (0, 1, 2, 0, 1, 2, ...)
                const row = Math.floor(index / gridWidth); // ตำแหน่งแถว (0, 0, 0, 1, 1, 1, ...)

                // 3. แปลงค่า Pixel เป็นหน่วยแผนที่
                const mapUnitOffsetX = (col * pixelSpacing) * resolution;
                const mapUnitOffsetY = (row * pixelSpacing) * resolution;

                // ตรวจสอบและคำนวณ Displacement Geometry ที่ถูกเลื่อนแล้ว (ตามโค้ดก่อนหน้า)
                const originalCoordinates = feature.getGeometry().getCoordinates();
                // ... (คำนวณ mapUnitOffsetX/mapUnitOffsetY)
                const newCoordinates = [
                    originalCoordinates[0] + mapUnitOffsetX,
                    originalCoordinates[1] + mapUnitOffsetY
                ];
                const displacedGeometry = new Point(newCoordinates);
                // 2. ดึงค่า Address
                const addressText = feature.get('address'); // 🚨 ตรวจสอบว่าชื่อ property คือ 'address'
                // 🛑 ส่วนที่เปลี่ยนเป็นสี่เหลี่ยมจัตุรัส
                // 3. สร้าง Style
                return new Style({
                    // ใช้ Geometry ที่ถูกเลื่อนแล้ว
                    geometry: displacedGeometry,

                    // Style สำหรับหมุดสี่เหลี่ยม
                    image: new RegularShape({
                        points: 4,
                        radius: 30,
                        angle: Math.PI / 4,
                        fill: new Fill({ color: 'rgba(255, 233, 37, 0.9)' }),
                        // stroke: new Stroke({ color: 'white', width: 1 })
                    }),

                    // Style สำหรับข้อความ
                    text: new Text({
                        text: addressText ? addressText.toString() : '', // กำหนดข้อความ
                        font: 'bold 12px sans-serif',
                        fill: new Fill({ color: 'black' }),
                        stroke: new Stroke({ color: 'white', width: 3 }),
                        offsetY: -15
                    })
                });
            }
            //------------------------------------------------------------
            // Road
            //------------------------------------------------------------
            const roadSource = new VectorSource({
                format: new GeoJSON(),
                loader: function (extent, resolution, projection) {
                    // 🔑 สร้าง BBOX string เพื่อดึงเฉพาะถนนที่อยู่ในหน้าจอ (ช่วยประหยัด CPU/Bandwidth)
                    const bbox = extent.join(',') + ',' + projection.getCode();

                    const url = `${dataWFS}&version=2.0.0&request=GetFeature` +
                        `&typeName=SuratCityMap:Road` +
                        `&outputFormat=application/json` +
                        `&srsname=EPSG:3857` +
                        `&bbox=${bbox}`; // 💡 ส่ง BBOX ไปด้วย

                    fetch(url, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (!res.ok) throw new Error('Network response was not ok');
                            return res.json();
                        })
                        .then(geojson => {
                            const features = new GeoJSON().readFeatures(geojson);
                            // 💡 ถ้าใช้ bbox strategy ไม่ควรใช้ .clear() เพราะ OL จะจัดการ cache features ให้เอง
                            roadSource.addFeatures(features);
                        })
                        .catch(err => {
                            console.error('Error loading roads:', err);
                            roadSource.removeLoadedExtent(extent); // ให้ลองโหลดใหม่ถ้าพลาด
                        });
                },
                strategy: bboxStrategy, // 🔑 สำคัญมากสำหรับเลเยอร์เส้นถนนที่มีข้อมูลเยอะ
            });
            const roadStyle = function (feature) {
                return new Style({
                    // 1. ส่วนของเส้นถนน
                    stroke: new Stroke({
                        color: '#ffffff',
                        width: 5,
                    }),
                    // 2. ส่วนของตัวหนังสือ (Label)
                    text: new Text({
                        font: 'bold 14px Prompt, Calibri, sans-serif',
                        text: feature.get('roadcl_nam'), // 🔑 เปลี่ยน 'road_name' เป็นชื่อ Field ใน DB ของคุณ
                        placement: 'line', // 🔑 บังคับให้ตัวหนังสือวิ่งตามแนวเส้นถนน
                        overflow: true,        // บังคับให้แสดงตัวหนังสือแม้ว่าจุดกึ่งกลางเส้นจะอยู่นอกจอก็ตาม
                        // repeat: 300,           // ระยะห่างของชื่อถนน (หน่วย Pixel) 
                        // ยิ่งเลขน้อย ชื่อจะปรากฏซ้ำๆ ในหน้าจอถี่ขึ้น ทำให้ไม่หลุดจอ
                        fill: new Fill({
                            color: '#ffffff', // ตัวหนังสือสีขาว
                        }),
                        stroke: new Stroke({
                            color: '#000000', // Buffer สีดำ
                            width: 3,         // ความหนาของ Buffer
                        }),
                        offsetY: -2,         // ขยับตัวหนังสือขึ้นเหนือเส้นเล็กน้อย
                        textAlign: 'center',
                    }),
                });
            };
            const roadLayer = applyVisibilityTracker(new VectorLayer({
                title: 'เส้นถนน',
                source: roadSource,
                style: roadStyle,
                minZoom: 15,
            }), 'tax_road', true);
            //------------------------------------------------------------
            // Alert
            //------------------------------------------------------------
            // สร้าง VectorSource พร้อมโหลดผ่าน POST
            const alertSource = new VectorSource({
                format: new GeoJSON(),
                loader: function (extent, resolution, projection) {
                    fetch(dataWFS, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({}) // ถ้า backend สร้าง filter เอง
                    })
                        .then(res => res.json())
                        .then(geojson => {
                            console.log(geojson)
                            const features = new GeoJSON().readFeatures(geojson, {
                                // dataProjection: 'EPSG:4326',
                                featureProjection: projection
                            });
                            alertSource.clear(true);
                            alertSource.addFeatures(features);
                        })
                        .catch(err => {
                            console.error('🚨 Error loading alert layer:', err);
                        });
                }
            });
            const surveyAlertLayer = applyVisibilityTracker(new VectorLayer({
                title: 'แจ้งเตือนการสำรวจ',
                source: alertSource,
                style: surveyAlertLayerStyleFunction,
            }), 'tax_survey_alert', false);
            function surveyAlertLayerStyleFunction(feature) {
                return new Style({
                    fill: new Fill({
                        color: 'rgba(32, 189, 50, 0.45)',
                    }),
                    stroke: new Stroke({
                        color: 'rgb(3, 127, 17)', // สีขอบ
                        width: 2
                    }),
                    // text: new Text({
                    //     text: feature.get('parcel_cod') || '', // หรือเปลี่ยนเป็น 'parcel_cod' หรือ field ที่ต้องการ
                    //     fill: new Fill({ color: '#000' }),
                    //     stroke: new Stroke({
                    //         color: '#fff',
                    //         width: 2,
                    //     }),
                    //     overflow: true,
                    //     font: '14px sans-serif'
                    // }),
                });
            }
            var taxmapLayersGroup = new LayerGroup({
                title: 'ชั้นข้อมูลแผนที่ภาษี',
                layers: [parcel, building, building2569LabelLayer, parcelLabelLayer, ltaxBuildingLayer, roadLayer, surveyAlertLayer, measureVector]
            })
            //------------------------------------------------------------
            //--- loadBBoxLayer ---
            //------------------------------------------------------------
            //ฟังก์ชันสำหรับโหลดข้อมูลแปลงที่ดิน และบ้านเลขที่ตาม BBOX
            const loadBBoxLayer = (map) => {
                const view = map.getView();
                const extent = view.calculateExtent(map.getSize());
                const currentZoom = view.getZoom();

                // 💡 เช็คระดับซูม < 18 ให้ล้างข้อมูลทั้ง 2 ชั้น
                if (currentZoom < 18) {
                    parcelSource.clear();
                    building2569Source.clear(); // 🟢 ล้างข้อมูลบ้านเลขที่ด้วย
                    return;
                }

                if (extent.some(val => val === null) || !isFinite(extent[0])) {
                    console.warn('Load skipped: View not ready.');
                    return;
                }

                const projection = view.getProjection();
                const crsCode = projection.getCode();
                const token = localStorage.getItem('token');
                const bboxString = extent.join(',') + ',' + crsCode;

                // 1. URL WFS สำหรับชั้นแปลงที่ดิน (Parcel)
                const wfsParcelUrl = `${dataWFS}` +
                    `&version=2.0.0&request=GetFeature&srsname=EPSG:3857&typeName=SuratCityMap:Parcel` +
                    `&outputFormat=application/json&CRS=${crsCode}` +
                    `&bbox=${bboxString}`;

                // 🟢 2. URL WFS สำหรับชั้นอาคาร/บ้านเลขที่ (ระบุ typeName ของอาคาร)
                const wfsBuildingUrl = `${dataWFS}` +
                    `&version=2.0.0&request=GetFeature&srsname=EPSG:3857&typeName=SuratCityMap:Building2569` + // 👈 เปลี่ยนเป็นชื่อ Layer อาคารบน GeoServer
                    `&outputFormat=application/json&CRS=${crsCode}` +
                    `&bbox=${bboxString}`;

                const headers = { 'Authorization': `Bearer ${token}` };

                // 🚀 ยิง Request พร้อมกันด้วย Promise.all
                Promise.all([
                    fetch(wfsParcelUrl, { headers }).then(res => res.json()),
                    fetch(wfsBuildingUrl, { headers }).then(res => res.json())
                ])
                    .then(([parcelGeojson, buildingGeojson]) => {
                        // --- 1. จัดการข้อมูล แปลงที่ดิน ---
                        const parcelFeatures = new GeoJSON().readFeatures(parcelGeojson, {
                            featureProjection: projection
                        });
                        parcelSource.clear();
                        parcelSource.addFeatures(parcelFeatures);

                        // --- 🟢 2. จัดการข้อมูล บ้านเลขที่ (Building) ---
                        const buildingFeatures = new GeoJSON().readFeatures(buildingGeojson, {
                            featureProjection: projection
                        });
                        building2569Source.clear();
                        building2569Source.addFeatures(buildingFeatures);

                        // console.log("✅ Load Parcel & Building BBOX successful.");
                    })
                    .catch(err => console.error('Error loading map features:', err));
            };
            //------------------------------------------------------------
            // ---Revenue---
            //------------------------------------------------------------
            var wasteFeeAlertLayer = new VectorImageLayer({
                title: 'ชำระค่าจัดเก็บขยะแล้ว',
                source: new VectorSource({
                    url: wasteFeeAlertUrl,
                    format: new GeoJSON({
                        featureProjection: 'EPSG:3857'
                    })
                }),
                style: wasteFeeAlertStyle,
                visible: false
            })
            var wasteFeeLayersGroup = new LayerGroup({
                title: 'ชั้นข้อมูลจัดเก็บค่าขยะ',
                layers: [wasteFeeAlertLayer]
            })
            //------------------------------------------------------------
            // --- Drone ---
            //------------------------------------------------------------
            const droneLayer = new TileLayer({
                title: 'ภาพถ่ายโดรน',
                // 🔑 ตั้งค่า Zoom Range ตามที่คุณ Seeding ใน GWC
                minZoom: 20, // ตัวอย่าง: เริ่มแสดงผลที่ Zoom 16
                type: 'base',
                source: new XYZ({
                    // 🔑 ชี้ไปที่ Proxy Endpoint ใหม่
                    // {layer} คือชื่อ Layer (your_workspace:your_orthophoto_mosaic)
                    url: `${dataGWC}/raster/SuratCityMap:Drone2568/{z}/{x}/{y}`,

                    // 🔑 กำหนดพารามิเตอร์ที่จำเป็นในการสร้าง URL (ไม่ใช้ token ใน source เพราะ proxy จัดการแล้ว)
                    tileLoadFunction: function (imageTile, src) {
                        // โหลดภาพผ่าน URL proxy ที่สร้างขึ้น
                        imageTile.getImage().src = src;
                    },

                    // 💡 เพื่อลดปัญหา CORS
                    crossOrigin: 'anonymous',

                    // 💡 กำหนด Output Format (ต้องตรงกับ Format ที่ขอใน Proxy)
                    projection: 'EPSG:3857',
                    // tileGrid: createXYZ(),
                    visible: true
                }),
            });

            //------------------------------------------------------------
            //----- Layers Group On roles -----
            //------------------------------------------------------------
            // 🗺️ ฟังก์ชันคืนค่า Layers Group ตามสิทธิ์ผู้ใช้งาน (อ่านง่าย ชัดเจน ไม่ต้องพึ่ง switch-case ยาวๆ)
            const getLayersByRole = (userRoles) => {
                // แปลงให้เป็น Array เสมอ เผื่อ user.roles ส่งมาเป็นตัวเลข หรือสตริงเดี่ยว
                const rolesArray = Array.isArray(userRoles) ? userRoles.map(String) : [String(userRoles)];

                const hasRole = (targetRoles) => rolesArray.some(role => targetRoles.includes(role));

                // 1. System Admin (100) -> เห็นหมดทุก Layer
                if (hasRole(ROLE_ADMIN)) {
                    return [basemapLayersGroup, taxmapLayersGroup, welfareLayersGroup, locationLayer];
                }

                // 2. กองสวัสดิการฯ (200)
                if (hasRole(ROLE_WELFARE)) {
                    return [basemapLayersGroup, taxmapLayersGroup, welfareLayersGroup];
                }

                // 3. ส่วนพัฒนารายได้ / ค่าขยะ (300, 301)
                if (hasRole(ROLE_REVENUE)) {
                    return [basemapLayersGroup, taxmapLayersGroup, communityAreaLayersGroup];
                }

                // 4. กองแผนที่ภาษี / ทรัพย์สิน (101, 102, 103, 104)
                if (hasRole(ROLE_TAXMAP) || hasRole(ROLE_PROPERTY_REGISTER)) {
                    return [basemapLayersGroup, taxmapLayersGroup, communityAreaLayersGroup];
                }
                // 4. สำนักช่าง (400, 401)
                if (hasRole(ROLE_PUBLIC_WORKS)) {
                    return [basemapLayersGroup, taxmapLayersGroup, communityAreaLayersGroup];
                }

                // 🔑 Default: ผู้ใช้งานทั่วไป หรือไม่มี Role ตรง -> ให้เห็นแค่แผนที่ฐาน (Basemap)
                return [basemapLayersGroup];
            };

            // 🚀 สั่งสร้าง OpenLayers Map ด้วย Layers ที่ดึงมาตามสิทธิ์
            const initialMap = new Map({
                target: mapElement.current,
                layers: getLayersByRole(user?.roles),
                view: mapView,
                controls: []
            });


            // 3. BBOX Loading Control
            // ***********************************************
            let moveendKey = null; // 💡 ประกาศตัวแปรสำหรับ key

            if (initialMap) {
                // 1. สั่งโหลดครั้งแรก
                loadBBoxLayer(initialMap, dataWFS, parcelSource, token);

                // 2. เพิ่ม Listener สำหรับการโหลดซ้ำเมื่อมีการแพน/ซูม
                // 🔑 เก็บ Key ในตัวแปรที่ประกาศไว้
                moveendKey = initialMap.on('moveend', () => {
                    loadBBoxLayer(initialMap, dataWFS, parcelSource, token);
                    // ... (ทำซ้ำสำหรับ Source อื่นๆ)
                })
            }

            //------------------------------------------------------------
            //FullScreen Button
            //------------------------------------------------------------
            var fsButton = document.createElement('button');
            fsButton.innerHTML = '<img src="images/fullscreen.svg" alt="" style="width:20px;height:20px;filter:brightness(0) invert(1);vertical-align:middle"></img>';
            fsButton.className = 'controlsButton';

            var fsElement = document.createElement('div');
            fsElement.className = 'fullscreenButtonDiv';
            fsElement.appendChild(fsButton);

            var fsControl = new Control({
                element: fsElement
            })
            var fsButtonFlag = false;

            fsButton.addEventListener("click", () => {
                fsButton.classList.toggle('clicked');
                fsButtonFlag = !fsButtonFlag;
                var mapEle = document.getElementById("map");
                if (fsButtonFlag) {
                    if (mapEle.requestFullscreen) {
                        mapEle.requestFullscreen();
                    } else if (mapEle.msRequestFullscreen) {
                        mapEle.msRequestFullscreen();
                    } else if (mapEle.mozRequestFullscreen) {
                        mapEle.mozRequestFullscreen();
                    } else if (mapEle.webkitRequestFullscreen) {
                        mapEle.webkitRequestFullscreen();
                    }
                }
                else {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    }
                }
            })
            initialMap.addControl(fsControl);

            //------------------------------------------------------------
            //Layers Switcher
            //------------------------------------------------------------
            var layerSwitcher = new LayerSwitcher({
                activationMode: 'click',
                reverse: true,
                groupSelectStyle: 'group'
            });
            initialMap.addControl(layerSwitcher);

            //------------------------------------------------------------
            //Home Control Button
            //------------------------------------------------------------
            var homeButton = document.createElement('button');
            homeButton.innerHTML = '<img src="images/home.svg" alt="" height="25px" width="25px" style="filter: brightness(0) invert(1)"></img>';
            homeButton.className = 'controlsButton';

            var homeElement = document.createElement('div');
            homeElement.className = 'homeButtonDiv';
            homeElement.appendChild(homeButton);

            var homeControl = new Control({
                element: homeElement
            })
            homeButton.addEventListener("click", () => {
                initialMap.getView().setCenter([
                    // ตั้งค่า Home ไว้ที่สำนักงานเทศบาลนครสุราษฎร์ธานี
                    11057392.46284881,
                    1021704.81859881,
                    11057502.49480739,
                    1021843.87213667
                ])
            })
            initialMap.addControl(homeControl);

            //------------------------------------------------------------
            // My Location Control
            //------------------------------------------------------------
            const locationButton = document.createElement('button');
            locationButton.innerHTML = '<img src="images/my-location.svg" alt="" style="width:25px;height:25px;filter:brightness(0) invert(1);vertical-align:middle"></img>';
            locationButton.className = 'controlsButton';

            const locationElement = document.createElement('div');
            locationElement.className = 'locationButtonDiv';
            locationElement.appendChild(locationButton);

            const locationControl = new Control({ element: locationElement });

            locationButton.addEventListener('click', () => {
                const coordinates = geolocation.getPosition();
                if (coordinates) {
                    mapView.animate({
                        center: coordinates,
                        zoom: 20,
                        duration: 1000,
                    });
                } else {
                    alert('ไม่สามารถดึงตำแหน่งปัจจุบันได้ กรุณาเปิด GPS/Permission');
                }
            });
            initialMap.addControl(locationControl);

            //------------------------------------------------------------
            // --- INFO BUTTON ---
            //------------------------------------------------------------
            var popupCheck = true;
            var gid;
            var gidCheck = true;
            var container;
            var content;
            var popup;
            var featureInfoButton = document.createElement('button');
            featureInfoButton.innerHTML = '<img src="images/identify.svg" alt="" height="25px" width="25px" style="filter: brightness(0) invert(1)"></img>';
            featureInfoButton.className = 'controlsButton';
            featureInfoButton.id = 'featureInfoButton';
            var featureInfoElement = document.createElement('div');
            featureInfoElement.className = 'featureInfoDiv';
            featureInfoElement.appendChild(featureInfoButton);
            var featureInfoControl = new Control({
                element: featureInfoElement
            })
            var featureInfoFlag = false;
            featureInfoButton.addEventListener("click", () => {
                featureInfoButton.classList.toggle('clicked');
                featureInfoFlag = !featureInfoFlag;
                if (!featureInfoFlag) {
                    initialMap.removeOverlay(popup);
                    gidCheck = true;
                    popupCheck = true;
                    gid = '';
                    popup.setPosition(undefined);
                }
                if (measureLengthFlag) {
                    measureLengthButton.classList.toggle('clicked');
                    measureLengthFlag = false
                    removeMeasureInteraction()
                }
                if (measureAreaFlag) {
                    measureAreaFlag = !measureAreaFlag
                    measureAreaButton.classList.toggle('clicked');
                    removeMeasureInteraction()
                }
            })
            initialMap.addControl(featureInfoControl);
            container = document.getElementById('popup');
            content = document.getElementById('popup-content');
            popup = new Overlay({
                element: container,
                autoPan: {
                    animation: {
                        duration: 250,
                    }
                }
            });
            initialMap.on('singleclick', function (evt) {
                if (!featureInfoFlag) return;

                // 🔑 1. ล้างตำแหน่ง Pop-up และ State ข้อมูลทั้งหมดทันทีที่จิ้มแผนที่
                popup.setPosition(undefined);
                resetAllInfoStates();

                if (popupCheck && gidCheck) {
                    const resolution = mapView.getResolution();
                    const projection = mapView.getProjection();
                    const url = parcel.getSource().getFeatureInfoUrl(evt.coordinate, resolution, projection, {
                        'INFO_FORMAT': 'application/json',
                        'propertyName': 'dn,parcel_cod,old_parcel,land_area,p_typ_txt,gid'
                    });

                    verifyToken();

                    setGoogleMapLink(olProj.transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326'));

                    if (url) {
                        fetch(url, {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        })
                            .then(response => {
                                if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
                                return response.json();
                            })
                            .then(data => {
                                if (data?.features?.length > 0) {
                                    const feature = data.features[0];
                                    const props = feature.properties;

                                    setLandInfo(props);
                                    gidCheck = props.gid !== gid;

                                    if (gidCheck) {
                                        container.style.display = 'block';
                                        initialMap.addOverlay(popup);
                                        popup.setPosition(evt.coordinate);
                                        gid = props.gid;

                                        setAllBuildingInfo([]);

                                        // 🟢 1. ดึงข้อมูลอาคารและภาพถ่าย
                                        if (props.old_parcel) {
                                            fetchLtaxOnlineData(
                                                props.old_parcel,
                                                setLtaxOnlineBuildings,
                                                setLtaxOnlineLands,
                                                setLtaxOnlineBuildingLoading
                                            );
                                            setOldParcel(props.old_parcel);
                                        } else {
                                            setOldParcel(null);
                                        }

                                        if (props.parcel_cod) {
                                            fetchSurveyBuilding(props.parcel_cod, setSurveyBuildings, setSurveyBuildingLoading);
                                            fetchSurveyImages(props.parcel_cod, setLandImagesUrl, setBuildingImagesURL, setSurveyImagesLoading);
                                            setParcelCode(props.parcel_cod);
                                        } else {
                                            setParcelCode(null);
                                        }

                                        // 🟢 2. ยิง Log บันทึกประวัติ
                                        logMapActivity('VIEW_INFO', {
                                            parcel_cod: props.parcel_cod || null,
                                            old_parcel: props.old_parcel || null,
                                            keyword: props.dn ? `โฉนด: ${props.dn}` : null
                                        });

                                        // 🟢 3. จัดการฟอร์แมตเนื้อหาใน Pop-up
                                        const parcelCodStr = `รหัสแปลงที่ดิน : ${props.parcel_cod || 'ไม่มีข้อมูล'}`;
                                        const oldParcelCodeStr = `รหัสแปลงที่ดินเก่า : ${props.old_parcel || 'ไม่มีข้อมูล'}`;
                                        const parcelTypeStr = `ประเภทเอกสารสิทธิ์ : ${props.p_typ_txt || 'ไม่มีข้อมูล'}`;
                                        const dnStr = `เลขเอกสารสิทธิ์ : ${props.dn || 'ไม่มีข้อมูล'}`;

                                        let landAreaStr = 'เนื้อที่ : ไม่มีข้อมูล';
                                        if (props.land_area) {
                                            const areaArr = props.land_area.split("-");
                                            landAreaStr = `เนื้อที่ : ${areaArr[0] || 0} ไร่ ${areaArr[1] || 0} งาน ${areaArr[2] || 0} ตรว.`;
                                        }

                                        content.innerHTML = `${parcelCodStr}<br>${oldParcelCodeStr}<br>${parcelTypeStr}<br>${dnStr}<br>${landAreaStr}`;
                                    } else {
                                        // กรณีจิ้มแปลงเดิมซ้ำ ให้รีเซ็ต
                                        resetPopupState();
                                    }
                                } else {
                                    // ไม่พบ Feature (จิ้มโดนพื้นที่ว่าง)
                                    resetPopupState();
                                }
                            })
                            .catch(err => {
                                console.error('Fetch feature info error:', err);
                                resetPopupState();
                            });
                    } else {
                        resetPopupState();
                    }
                } else {
                    resetPopupState();
                }
            });

            // 🔑 2. ฟังก์ชันล้าง State ข้อมูลรายละเอียดทั้งหมด
            function resetAllInfoStates() {
                setLandInfo(null);
                setOldParcel(null);
                setParcelCode(null);
                setLandImagesUrl([]);
                setBuildingImagesURL([]);
                setSurveyBuildings([]);
                setLtaxOnlineBuildings && setLtaxOnlineBuildings([]);
                setLtaxOnlineLands && setLtaxOnlineLands([]);
                setltaxOnlineData([]);
                setAllBuildingInfo([]);
            }

            // 🔑 3. ฟังก์ชันรีเซ็ต Pop-up + ล้าง State ข้อมูล
            function resetPopupState() {
                initialMap.removeOverlay(popup);
                gidCheck = true;
                popupCheck = true;
                gid = '';
                popup.setPosition(undefined);
                resetAllInfoStates(); // สั่งล้าง State ข้อมูลทั้งหมดด้วย
            }
            //------------------------------------------------------------
            //Query Button
            //------------------------------------------------------------
            var queryButtonJSON;
            var queryButtonOverlay;
            var queryButton = document.createElement('button');
            queryButton.innerHTML = '<img src="images/query.svg" alt="" height="25px" widht="25px" style="filter:brightness(0) invert(1)"></img>';
            queryButton.className = 'controlsButton';
            queryButton.id = 'queryButton';

            var queryButtonElement = document.createElement('div');
            queryButtonElement.className = 'queryButtonDiv';
            queryButtonElement.appendChild(queryButton);
            var queryButtonControl = new Control({
                element: queryButtonElement
            })
            var queryButtonFlag = false;
            initialMap.addControl(queryButtonControl);
            //add Searchbar to Overlay
            var searchbarElement = document.getElementById('attributeQueryDiv')
            var searchbar = new Control({
                element: searchbarElement
            })
            initialMap.addControl(searchbar);
            document.getElementById("attributeQueryDiv").style.display = "none";
            queryButton.addEventListener("click", () => {
                // //Set Placeholder
                // var placeHolderValue = document.getElementById('selectLayer');
                // placeHolderValue.addEventListener('change', () => {
                //     document.getElementById("enterValue").placeholder = placeHolderValue.options[placeHolderValue.selectedIndex].textContent.substring(5);
                // })
                queryButton.classList.toggle('clicked');
                queryButtonFlag = !queryButtonFlag;
                document.getElementById("map").style.cursor = "default";
                if (queryButtonFlag) {
                    if (queryButtonJSON) {
                        queryButtonJSON.getSource().clear();
                        initialMap.removeLayer(queryButtonJSON);
                    }

                    if (queryButtonOverlay) {
                        queryButtonOverlay.getSource().clear();
                        initialMap.removeLayer(queryButtonOverlay);
                    }
                    document.getElementById("attributeQueryDiv").style.display = "flex";

                    addMapLayerList();
                } else {
                    document.getElementById("attributeQueryDiv").style.display = "none";
                    document.getElementById("attListDiv").style.display = "none";

                    if (queryButtonJSON) {
                        queryButtonJSON.getSource().clear();
                        initialMap.removeLayer(queryButtonJSON);
                    }

                    if (queryButtonOverlay) {
                        queryButtonOverlay.getSource().clear();
                        initialMap.removeLayer(queryButtonOverlay);
                    }
                }
            })
            function addMapLayerList() {
                document.getElementById('attributeQueryDiv').addEventListener('submit', async (e) => {
                    e.preventDefault();
                    setBackDropLoading(true);

                    const searchType = searchSelectRef.current.value;
                    let queryValue = document.getElementById('searchValue').value.trim();
                    const queryLayerValue = "SuratCityMap:Parcel";
                    const queryOperatorValue = "=";
                    let queryAttributeValue = 'dn';

                    // 🟢 ฟังก์ชันย่อช่วยสร้าง WFS URL และสั่งโหลดแผนที่ + ส่ง Log
                    const executeSearch = (attribute, value) => {
                        const url = `${dataWFS}&version=2.0.0&request=GetFeature&srsname=EPSG:3857&typeName=${queryLayerValue}&CQL_FILTER=${attribute}+${queryOperatorValue}+'${value}'&outputFormat=application/json`;

                        // 1. เพิ่ม Layer ลงแผนที่ตามปกติ
                        newaddGeoJsonToMap(url);

                        // 🟢 2. ยิง Log บันทึกประวัติการค้นหาไปฝั่ง Backend (Fire-and-Forget)
                        logMapActivity('SEARCH', {
                            keyword: `${searchType}: ${value}`,
                            parcel_cod: attribute === 'parcel_cod' ? value : null,
                            old_parcel: attribute === 'old_parcel' ? value : null
                        });
                    };

                    const triggerError = (msg) => {
                        setSearchErrorOpen(true);
                        setSearchErrorText(msg);
                        setBackDropLoading(false);
                    };

                    switch (searchType) {
                        case 'เลขที่โฉนด':
                            if (queryValue !== '') {
                                executeSearch('dn', queryValue);
                            } else {
                                triggerError('กรุณากรอกเลขเอกสารสิทธิ์เพื่อค้นหา');
                            }
                            break;

                        case 'รหัสแปลงที่ดิน':
                            if (queryValue !== '') {
                                queryValue = queryValue.toUpperCase(); // 🟢 แก้ไขจาก .toUpperCase(0) เป็น .toUpperCase()
                                executeSearch('parcel_cod', queryValue);
                            } else {
                                triggerError('กรุณากรอกรหัสแปลงที่ดินเพื่อค้นหา');
                            }
                            break;

                        case 'รหัสแปลงที่ดินเก่า':
                            if (queryValue !== '') {
                                queryValue = queryValue.toUpperCase();
                                executeSearch('old_parcel', queryValue);
                            } else {
                                triggerError('กรุณากรอกรหัสแปลงที่ดินเพื่อค้นหา');
                            }
                            break;

                        case 'บ้านเลขที่':
                            const roadSearch = document.getElementById('roadSearch').value.trim();
                            const mooSearch = document.getElementById('mooSearch').value.trim();

                            if (queryValue !== '' && (roadSearch !== '' || mooSearch !== '')) {
                                const foundParcelCode = await fecthLtaxOnlineAddress(
                                    queryValue,
                                    roadSearch,
                                    mooSearch,
                                    tumbolQueryRef.current.value
                                );

                                if (foundParcelCode) {
                                    executeSearch('dn', foundParcelCode);
                                } else {
                                    triggerError('ไม่พบข้อมูลสิ่งปลูกสร้าง');
                                }
                            } else {
                                triggerError('กรุณากรอกข้อมูลบ้านเลขที่และถนนหรือหมู่เพื่อค้นหา');
                            }
                            break;

                        default:
                            setBackDropLoading(false);
                            break;
                    }
                });
            }
            function newaddGeoJsonToMap(url) {
                const token = localStorage.getItem('token'); // ✅ ดึง token ที่เก็บไว้

                if (queryButtonJSON) {
                    queryButtonJSON.getSource().clear();
                    initialMap.removeLayer(queryButtonJSON);
                }


                const querySource = new VectorSource({
                    format: new GeoJSON({ featureProjection: 'EPSG:3857' }),

                    // ✅ loader แทน url
                    loader: function (extent, resolution, projection) {
                        fetch(url, {
                            method: 'GET',
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Accept': 'application/json'
                            }
                        })
                            .then(res => res.json())
                            .then(data => {
                                // console.log('🔎 GeoJSON:', data); // <<== ตรวจโครงสร้างที่นี่ก่อน
                                if (data.features && data.features.length > 0) {
                                    // console.log(data.features && data.features.length > 0)
                                    const features = new GeoJSON().readFeatures(data, {
                                        // dataProjection: 'EPSG:4326',
                                        featureProjection: projection
                                    });
                                    querySource.clear(true);
                                    querySource.addFeatures(features);
                                } else {
                                    setSearchErrorText('ไม่พบข้อมูล');
                                    setSearchErrorOpen(true);
                                }
                            })
                            .catch(err => {
                                console.error('❌ Loader fetch error:', err);
                                setSearchErrorText('เกิดข้อผิดพลาดขณะโหลดข้อมูล');
                                setSearchErrorOpen(true);
                            });
                    }
                });

                queryButtonJSON = new VectorImageLayer({
                    source: querySource,
                    style: new OlStyle({
                        fill: new Fill({ color: 'rgba(255, 0, 0, 0.4)' }),
                        stroke: new Stroke({ color: 'rgba(176, 0, 0,1)', width: 3 }),
                        image: new Circle({ radius: 7, fill: new Fill({ color: '#e31a1c' }) })
                    }),
                });

                querySource.on('addfeature', function () {
                    const extent = querySource.getExtent();
                    initialMap.getView().fit(extent, {
                        duration: 1590,
                        size: initialMap.getSize(),
                        maxZoom: 21
                    });
                    // console.log('📌 Extent:', extent);
                });

                // ✅ ตรวจสอบล่วงหน้า (optional)
                const xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.setRequestHeader('Authorization', `Bearer ${token}`); // ✅ เพิ่ม header
                xhr.setRequestHeader('Accept', 'application/json');        // (optional)

                xhr.onload = function () {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        const responseData = JSON.parse(xhr.responseText);
                        if (responseData.features && responseData.features.length > 0) {
                            initialMap.addLayer(queryButtonJSON);
                            setBackDropLoading(false);
                        } else {
                            setSearchErrorText('ไม่พบข้อมูล');
                            setSearchErrorOpen(true);
                        }
                    } else {
                        setSearchErrorText('ข้อมูลค้นหาไม่ถูกต้อง');
                        setSearchErrorOpen(true);
                    }
                };

                xhr.onerror = function () {
                    console.log('❌ Network error');
                    setSearchErrorText('ค้นหาไม่สำเร็จ');
                    setSearchErrorOpen(true);
                };

                xhr.send();
            }


            //------------------------------------------------------------
            // Measure SecTion
            //------------------------------------------------------------
            /**
             * Currently drawn feature.
             * @type {import("../src/ol/Feature.js").default}
             */
            let sketch;

            /**
             * The help tooltip element.
             * @type {HTMLElement}
             */
            let helpTooltipElement;

            /**
             * Overlay to show the help messages.
             * @type {Overlay}
             */
            let helpTooltip;

            /**
             * The measure tooltip element.
             * @type {HTMLElement}
             */
            let measureTooltipElement;

            /**
             * Overlay to show the measurement.
             * @type {Overlay}
             */
            let measureTooltip;

            /**
             * Message to show when the user is drawing a polygon.
             * @type {string}
             */
            const continuePolygonMsg = 'คลิ๊กเพื่อวางหลักหมุดวัดพื้นที่';

            /**
             * Message to show when the user is drawing a line.
             * @type {string}
             */
            const continueLineMsg = 'คลิ๊กเพื่อวางหลักหมุดวัดระยะ';

            /**
             * Handle pointer move.
             * @param {import("../src/ol/MapBrowserEvent").default} evt The event.
             */
            const pointerMoveHandler = function (evt) {
                if (evt.dragging) {
                    return;
                }
                /** @type {string} */
                let helpMsg = 'คลิ๊กเพื่อวางหลักหมุดเริ่มต้น';

                if (sketch) {
                    const geom = sketch.getGeometry();
                    if (geom instanceof Polygon) {
                        helpMsg = continuePolygonMsg;
                    } else if (geom instanceof LineString) {
                        helpMsg = continueLineMsg;
                    }
                }
                if (helpTooltipElement && helpMsg) {
                    helpTooltipElement.innerHTML = helpMsg;
                    helpTooltipElement.classList.remove('hidden')
                }
                if (helpTooltip) {
                    helpTooltip.setPosition(evt.coordinate);
                }
            }
            initialMap.on('pointermove', pointerMoveHandler)

            initialMap.getViewport().addEventListener('mouseout', function () {
                helpTooltipElement?.classList.add('hidden')
            });


            let draw; // global so we can remove it later
            const snapInteraction = new Snap({
                // ดึง source ของ layer ที่มี features ที่ต้องการให้จุดไปยึดติด
                source: parcelLabelLayer.getSource(),
                // ตั้งค่าให้ยึดติดกับ 'หมุด' หรือ จุดยอด
                vertex: true,
                // ปิดการยึดติดกับขอบ
                edge: false
            });

            /**
             * Format length output.
             * @param {LineString} line The line.
             * @return {string} The formatted length.
             */
            const formatLength = function (line) {
                if (line) {
                    const length = getLength(line)
                    let output
                    if (length > 100) {
                        output = `${Math.round((length / 1000) * 100) / 100} กิโลเมตร`;
                    } else {
                        output = `${Math.round(length * 100) / 100} เมตร`
                    }
                    return output
                }
            }

            /**
             * Format area output.
             * @param {Polygon} polygon The polygon.
             * @return {string} Formatted area.
             */
            const formatArea = function (polygon) {
                const area = getArea(polygon)
                let output
                let rai = 0
                let ngan = 0
                let squareWa = 0
                rai = Math.floor((Math.round(area * 100) / 100) / 1600)
                ngan = Math.floor((area - (rai * 1600)) / 400)
                squareWa = ((area - (rai * 1600) - (ngan * 400)) / 4).toFixed(1)
                // console.log(rai)
                // console.log(ngan)
                // console.log(squareWa)
                if (area > 1000000) {
                    output = `${Math.round((area / 1000000) * 100) / 100} ตารางกิโลเมตร<br>${rai} ไร่ ${ngan} งาน ${squareWa} ตารางวา`
                } else {
                    output = `${Math.round(area * 100) / 100} ตารางเมตร<br>${rai} ไร่ ${ngan} งาน ${squareWa} ตารางวา`
                }
                return output
            }
            function addInteraction(measureType) {
                const type = measureType === 'area' ? 'Polygon' : 'LineString';
                draw = new Draw({
                    source: source,
                    type: type,
                    style: new Style({
                        // fill: new Fill({
                        // }),
                        // color: '#003a8c',
                        stroke: new Stroke({
                            color: 'rgba(255, 255, 0, 1)',
                            lineDash: [10, 10],
                            width: 3,
                        }),
                        image: new Circle({
                            radius: 5,
                            stroke: new Stroke({
                                color: 'rgba(255, 255, 0, 0.4)',
                            }),
                            fill: new Fill({
                                color: 'rgba(255, 255, 0, 0.4)',
                            }),
                        }),
                    }),
                });
                initialMap.addInteraction(draw);
                initialMap.addInteraction(snapInteraction); // 👈 เพิ่ม Snap ที่นี่
                createMeasureTooltip();
                createHelpTooltip();

                let listener;
                draw.on('drawstart', function (evt) {
                    // set sketch
                    sketch = evt.feature;

                    /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
                    let tooltipCoord = evt.coordinate;

                    listener = sketch.getGeometry().on('change', function (evt) {
                        const geom = evt.target;
                        let output;
                        if (geom instanceof Polygon) {
                            output = formatArea(geom);
                            tooltipCoord = geom.getInteriorPoint().getCoordinates();
                        } else if (geom instanceof LineString) {
                            output = formatLength(geom);
                            tooltipCoord = geom.getLastCoordinate();
                        }
                        measureTooltipElement.innerHTML = output;
                        measureTooltip.setPosition(tooltipCoord);
                    });
                });

                draw.on('drawend', function () {
                    measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
                    measureTooltip.setOffset([0, -7]);
                    // unset sketch
                    sketch = null;
                    // unset tooltip so that a new one can be created
                    measureTooltipElement = null;
                    createMeasureTooltip();
                    unByKey(listener);
                });
            }

            /**
             * Creates a new help tooltip
             */
            function createHelpTooltip() {
                if (helpTooltipElement) {
                    helpTooltipElement.parentNode.removeChild(helpTooltipElement);
                }
                helpTooltipElement = document.createElement('div');
                helpTooltipElement.className = 'ol-tooltip hidden';
                helpTooltip = new Overlay({
                    element: helpTooltipElement,
                    offset: [15, 0],
                    positioning: 'center-left',
                });
                initialMap.addOverlay(helpTooltip);
            }

            /**
             * Creates a new measure tooltip
             */
            function createMeasureTooltip() {
                if (measureTooltipElement) {
                    measureTooltipElement.parentNode.removeChild(measureTooltipElement);
                }
                measureTooltipElement = document.createElement('div');
                measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
                measureTooltip = new Overlay({
                    element: measureTooltipElement,
                    offset: [0, -15],
                    positioning: 'bottom-center',
                    stopEvent: false,
                    insertFirst: false,
                });
                initialMap.addOverlay(measureTooltip);
            }
            function removeMeasureInteraction() {
                initialMap.removeInteraction(draw)
                source.clear()
                initialMap.getOverlays().getArray().slice(0).forEach(function (overlay) {
                    initialMap.removeOverlay(overlay)
                })
            }
            //------------------------------------------------------------
            //Measure Length
            //------------------------------------------------------------
            var measureLengthButton = document.getElementById('measureLengthButton')
            measureLengthButton.className = 'controlsButton'
            var measureLengthButtonControl = new Control({
                element: measureLengthButton
            })
            initialMap.addControl(measureLengthButtonControl);
            var measureLengthFlag = false
            measureLengthButton.addEventListener("click", () => {
                measureLengthFlag = !measureLengthFlag
                measureLengthButton.classList.toggle('clicked');
                if (measureLengthFlag) {
                    if (measureAreaFlag) {
                        measureAreaFlag = !measureAreaFlag
                        measureAreaButton.classList.toggle('clicked');
                    }
                    if (featureInfoFlag) {
                        featureInfoButton.classList.toggle('clicked')
                        featureInfoFlag = false
                    }
                    removeMeasureInteraction()
                    addInteraction('length');
                } else {
                    removeMeasureInteraction()
                }
            })
            //------------------------------------------------------------
            //Measure Area
            //------------------------------------------------------------
            var measureAreaButton = document.getElementById('measureAreaButton')
            measureAreaButton.className = 'controlsButton'
            var measureAreaButtonControl = new Control({
                element: measureAreaButton
            })
            initialMap.addControl(measureAreaButtonControl);
            var measureAreaFlag = false
            measureAreaButton.addEventListener("click", () => {
                measureAreaFlag = !measureAreaFlag
                measureAreaButton.classList.toggle('clicked');
                if (measureAreaFlag) {
                    if (measureLengthFlag) {
                        measureLengthButton.classList.toggle('clicked');
                        measureLengthFlag = false
                    }
                    if (featureInfoFlag) {
                        featureInfoButton.classList.toggle('clicked')
                        featureInfoFlag = false
                    }
                    removeMeasureInteraction()
                    addInteraction('area');
                } else {
                    removeMeasureInteraction()
                }
            })
            setMap(initialMap)
            // ***********************************************
            // 4. Cleanup Function (ส่วนสำคัญที่แก้ ol_key error)
            // ***********************************************

            return () => {
                // 🔑 ตรวจสอบว่า initialMap มีอยู่ และ moveendKey ถูกสร้างขึ้น
                if (initialMap && moveendKey) {
                    // เรียก un() เพื่อยกเลิก Listener
                    initialMap.un('moveend', moveendKey);
                }
                initialMap?.setTarget(undefined);
            };
        }
        // eslint-disable-next-line
    }, [alertDnTest])

    return (
        <Box className='otherSide' id="otherSide">
            <ThemeProvider theme={theme}>
                <Box ref={mapElement} className="map-container" id='map'>
                    {/* <input
                        type="checkbox"
                        checked={droneLayerVisible}
                        onChange={(e) => setDroneLayerVisible(e.target.checked)}
                    />
                    แสดงแผนที่โดรน (Raster) */}
                    <Box
                        className="attributeQueryDiv"
                        id="attributeQueryDiv"
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1 },
                            '& .MuiButton-root': { m: 1 }
                        }}
                    >
                        <TextField
                            sx={{ width: '23ch' }}
                            select
                            label='ประเภทการค้นหา'
                            name="searchSelect"
                            id="searchSelect"
                            inputRef={searchSelectRef}
                            defaultValue="เลขที่โฉนด"
                            onChange={(e) => {
                                setSearchValue({
                                    ...searchValue,
                                    select: e.target.value,
                                    value: '',
                                    road: '',
                                    moo: ''
                                })
                            }}
                        >
                            <MenuItem value='เลขที่โฉนด' name="dn">ค้นหาเลขที่โฉนด</MenuItem>
                            <MenuItem value='รหัสแปลงที่ดิน' name="parcel_cod">ค้นหารหัสแปลงที่ดินใหม่</MenuItem>
                            <MenuItem value='รหัสแปลงที่ดินเก่า' name="old_parcel">ค้นหารหัสแปลงที่ดินเก่า</MenuItem>
                            <MenuItem value='บ้านเลขที่' name="address">ค้นหาบ้านเลขที่</MenuItem>
                        </TextField>
                        <TextField
                            sx={{ width: '20ch' }}
                            id="searchValue"
                            label={searchValue.select}
                            value={searchValue.value}
                            onChange={(e) => { setSearchValue({ ...searchValue, value: e.target.value.toLocaleUpperCase() }) }}
                            onFocus={e => {
                                e.target.select();
                            }}
                        />
                        {
                            searchValue?.select === 'บ้านเลขที่'
                                ?
                                <Row
                                    style={{ alignItems: 'center', marginRight: '10px' }}>
                                    <Col >
                                        <Row gutter={[8, 8]}>
                                            <Col >
                                                <TextField
                                                    className='Box-Seach-map'
                                                    // sx={{ width: '20ch' }}
                                                    id="roadSearch"
                                                    label="ถนน"
                                                    value={searchValue.road}
                                                    onChange={(e) => { setSearchValue({ ...searchValue, road: e.target.value }) }}
                                                    onFocus={e => {
                                                        e.target.select();
                                                    }}
                                                />
                                            </Col>
                                            <Col>
                                                <TextField
                                                    className='Box-Seach-map'
                                                    id="mooSearch"
                                                    label="หมู่"
                                                    value={searchValue.moo}
                                                    onChange={(e) => { setSearchValue({ ...searchValue, moo: e.target.value }) }}
                                                    onFocus={event => {
                                                        event.target.select();
                                                    }}
                                                />
                                            </Col>
                                            <Col>
                                                <TextField
                                                    className='Box-Seach-map'
                                                    select
                                                    label='ตำบล'
                                                    name="tumbolSearch"
                                                    id="tumbolSearch"
                                                    inputRef={tumbolQueryRef}
                                                    defaultValue={840101}
                                                >
                                                    <MenuItem value={840101}>ตลาด</MenuItem>
                                                    <MenuItem value={840102}>มะขามเตี้ย</MenuItem>
                                                    <MenuItem value={840105}>บางใบไม้</MenuItem>
                                                    <MenuItem value={840106}>บางชนะ</MenuItem>
                                                    <MenuItem value={840110}>บางกุ้ง</MenuItem>
                                                    <MenuItem value={840111}>คลองฉนาก</MenuItem>
                                                </TextField>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                : ""
                        }
                        <Col >
                            <Button
                                sx={{ padding: '0px 0px 0px 11px' }}
                                variant="contained"
                                color='success'
                                type='submit'
                                startIcon={<SearchIcon />}
                                id="attritbuteQuerySubmit"
                                className="attritbuteQuerySubmit Box-Seach-map"
                            />
                        </Col>
                        <Box className="attListDiv" id="attListDiv"></Box>
                    </Box >
                    <Button
                        id='measureLengthButton'
                        sx={{ mt: 1, ml: 1, height: 40 }}
                        fontSize='large'
                        startIcon={<StraightenIcon fontSize="large" color='neutral' />}
                    />
                    <Button
                        id='measureAreaButton'
                        sx={{ mt: 1, ml: 1, height: 40 }}
                        fontSize='large'
                        startIcon={<SquareFootIcon fontSize="large" color='neutral' />}
                    />
                    <Box
                        id="popup" className="featuresInfoPopup"
                        sx={{ minWidth: '60ch' }}
                    >
                        <Box id="popup-content" ></Box>
                        {/* <ParceInfoAccordion
                            surveyBuildings={surveyBuildings}
                            surveyBuildingLoading={surveyBuildingLoading}
                            surveyImagesLoading={surveyImagesLoading}
                            landImagesUrl={landImagesUrl}
                            buildingImagesURL={buildingImagesURL}
                            allBuildingInfo={allBuildingInfo}
                            ltaxBuildingLoading={ltaxBuildingLoading}
                            ltaxOnlineData={ltaxOnlineData}
                            ltaxOnlineBuildingLoading={ltaxOnlineBuildingLoading}
                        /> */}
                        <ParceInfoAccordion
                            surveyBuildings={surveyBuildings}
                            surveyBuildingLoading={surveyBuildingLoading}
                            surveyImagesLoading={surveyImagesLoading}
                            landImagesUrl={landImagesUrl}
                            buildingImagesURL={buildingImagesURL}
                            allBuildingInfo={allBuildingInfo}
                            ltaxBuildingLoading={ltaxBuildingLoading}
                            ltaxOnlineBuildings={ltaxOnlineBuildings} // 🟢 ส่งรายการสิ่งปลูกสร้าง
                            ltaxOnlineLands={ltaxOnlineLands}         // 🟢 ส่งรายการที่ดิน
                            ltaxOnlineBuildingLoading={ltaxOnlineBuildingLoading}
                        />
                        <Box sx={{ mt: 1 }}>
                            <Button
                                variant='contained'
                                color='secondary'
                                startIcon={<CreateIcon />}
                                onClick={() => navigate('/survey', { state: { dn: landInfo.dn, parcelcode: landInfo.parcel_cod, oldParcelCode: landInfo.old_parcel } })}
                            >
                                สำรวจ
                            </Button>
                            {/* <Button
                                variant='contained'
                                color='secondary'
                                startIcon={<CreateIcon />}
                                onClick={() => {
                                    window.open(`/survey?parcelCode=${encodeURIComponent(parcelCode)}&oldParcel=${encodeURIComponent(oldParcel)}`, '_blank');
                                }}
                            >
                                สำรวจ
                            </Button> */}
                            <Button
                                variant='contained'
                                color='secondary'
                                startIcon={<MapIcon />}
                                sx={{ ml: 1 }}
                                onClick={() => {
                                    window.open(`https://maps.google.com?q=${googleMapLink[1]},${googleMapLink[0]}`)
                                }}
                            >
                                Google Map
                            </Button>
                            {hasSurveyAccess && (
                                <>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        startIcon={<FolderIcon />}
                                        sx={{ ml: 1 }}
                                        onClick={() => {
                                            fetchViewData(landInfo.parcel_cod, setFolderData, setIsOpenFolderModal, setSearchErrorOpen, alertNoFolder);
                                            setIsOpenFolderModal(true);
                                        }}
                                    >
                                        ดูแฟ้มเอกสาร
                                    </Button>

                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        startIcon={<SearchIcon />}
                                        sx={{ ml: 1 }}
                                        onClick={() => {
                                            window.open(`/survey/search?parcelCode=${encodeURIComponent(parcelCode)}&oldParcel=${encodeURIComponent(oldParcel)}`, '_blank');
                                        }}
                                    >
                                        ค้นหาแบบสำรวจ
                                    </Button>

                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        sx={{ mt: 1 }}
                                        onClick={() => {
                                            window.open(`/trackdoc/print?parcelCode=${encodeURIComponent(parcelCode)}&oldParcel=${encodeURIComponent(oldParcel)}`, '_blank');
                                        }}
                                    >
                                        🖨️ พิมพ์บาร์โค้ด
                                    </Button>
                                </>
                            )}
                        </Box>
                    </Box>
                    <Modal
                        open={isOpenFolderModal}
                        onOk={handleFolderClose}
                        onCancel={handleFolderClose}
                        component="form"
                        width={900}
                    >
                        <Typography
                            style={{
                                fontWeight: '900',
                                fontSize: '1.5rem',
                                color: '#117c91',
                                margin: '10px 0px 10px 0px'
                            }} >
                            รหัสแปลงที่ดิน {parcelCode}
                        </Typography>
                        <Box>
                            {folderData?.length > 0
                                ? folderData?.map((view, index) => (
                                    <Box key={index} style={{ mg: '40px 10px 10px 10px' }}>
                                        <Row
                                            style={{
                                                display: 'flex',
                                                flexflow: 'row wrap',
                                                minWidth: '0',
                                                justifyContent: 'space-between',
                                                alignContent: 'center',
                                                alignItems: 'center',
                                                // mg: '40px 10px 10px 10px'
                                            }}>
                                            <Col>
                                                <Row>
                                                    <Typography style={{ fontWeight: '900' }} >
                                                        ประเภทเอกสาร :
                                                    </Typography>
                                                    {fileTypeData?.map((fileType) => (
                                                        fileType.id === view.type
                                                            ? <Typography key={index} value={fileType.id}>{fileType.type}</Typography>
                                                            : ''
                                                    ))}
                                                    {/* {typeName.map((data, index) => (<Typography key={index}>{data.idType === view.type ? data.type_name : ' '}</Typography>))} */}
                                                </Row>
                                                <Row>
                                                    <Typography style={{ fontWeight: '900' }} >
                                                        หมายเหตุ :
                                                    </Typography>
                                                    <Typography>
                                                        {view.note}
                                                    </Typography>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Image
                                            src={view.image.imageUrl}
                                        />
                                        <Divider orientation="left" className="divider" />
                                    </Box>
                                ))
                                : <Typography>ไม่มีข้อมูลแฟ้มเอกสาร</Typography>}
                        </Box>
                    </Modal>
                    <Snackbar
                        open={searchErrorOpen}
                        onClose={(event, reason) => {
                            if (reason === 'clickaway') {
                                setSearchErrorOpen(false)
                                setBackDropLoading(false)
                                return;
                            }
                        }}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                    >
                        <Alert variant="filled" severity="error" sx={{ width: '100%' }}>
                            {searchErrorText}
                        </Alert>
                    </Snackbar>
                </Box>
                <BackDropLoading backDropLoading={backDropLoading} />
            </ThemeProvider >
        </Box >
    );
}

export default MAP;